import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"filter"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M19.5 4H4.5L10.5 12.5V20H13.5V12.5L19.5 4Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19.5 4H4.5L10.5 12.5V20H13.5V12.5L19.5 4Z","fillRule":"evenodd","strokeLinecap":"square","strokeWidth":"props.strokeWidth","clipRule":"evenodd"}}]}]};

const Filter = Vue.extend<IconProps>({
  name: 'FilterIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'filter',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Filter;
